import React, { useEffect } from 'react';
import { Page, Toast } from 'react-weui';
import { history } from 'umi';
import { isWechatAuth, setAuthRedirect } from '@/utils/utils';
//
// import { getAppId, loginByCode } from '@/services/login';
// import { setToken } from '@/utils/token';
// import { isWechatAuth, setWechatAuth, clearWechatAuth, getAuthRedirect } from '@/utils/utils';
//
// const redirectToWechatServer = (appid, state = null) => {
//   const href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo&state=${state ? state : 'STATE'}#wechat_redirect`;
//   window.location = href;
// }

export default (props) => {

  const { match: { params: { share_id } } } = props;

  useEffect(() => {
    if (isWechatAuth()) {
      history.push('/live/home');
    } else if (share_id) {
      // Toast.loading('加载中...', 0);
      setAuthRedirect('/live/home');
      history.push(`/auth?state=${share_id}`);
    } else {
      history.push('/live/home');
    }
  }, []);

  // useEffect(() => {
  //   if (code) {
  //     const redirectUrl = getAuthRedirect();
  //     loginByCode({code}).then(res => {
  //       if (res && res.code === 200) {
  //         const { token } = res.data;
  //         setToken(token);
  //         setTimeout(() => {
  //           history.push(redirectUrl.replace(window.location.origin, ""));
  //         }, 1000);
  //       }
  //     }).finally(() => clearWechatAuth());
  //   } else {
  //     if (isWechatAuth()) return ;
  //     getAppId().then(res => {
  //       if (res && res.code === 200) {
  //         setWechatAuth();
  //         redirectToWechatServer(res.data, null);
  //       }
  //     })
  //   }
  // }, [code]);

  return (
    <Page className="toast" spacing>
      <Toast icon="loading" show={true}>处理中...</Toast>
    </Page>
  )
}

